import { useState, useEffect } from 'react';

/**
 * Hook to check if the screen is mobile (phone)
 * @param {number} breakpoint default to 640px to match Tailwind's sm breakpoint
 * @returns {boolean} true if the screen is mobile, false otherwise
 */
export function useIsMobile(breakpoint: number = 640) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, [breakpoint]);

  return isMobile;
}
